export const punctuation = {
  SLASH : "/",
  HYPHEN : "-",
  AND : "&",
  EQUAL_EQUAL : "==",
  DOLLAR : "$"
}